import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
import Axios from "axios";

//COMPONENTS
import UploadComponent from "../../uploadComponent/config";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as ConfigStyles from "./styles";

function Config() {
    const dispatch = useDispatch();

    const [data, setData] = useState({
        section1Image: "",
        section1Name: "",
        section1Position: "",
        section2Image: "",
        section2Name: "",
        section2Position: "",
        section3Image: "",
        section3Name: "",
        section3Position: "",
        section4Image: "",
        section4Name: "",
        section4Position: ""
    });
    const [buttonColor, setButtonColor] = useState("primary");

    const fileDetails = {
        fileSize: 8,
        fileMessage: "Images only"
    };

    const maxLength = 25;

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("Style Configuration - Introductions Row"));
        onLoad();
    }, []);

    function onLoad() {
        Axios.post("/style/photoRow/load")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    console.log(data);
                    const temp = {
                        section1Image: data.info.section1Image,
                        section1Name: data.info.section1Name,
                        section1Position: data.info.section1Position,
                        section2Image: data.info.section2Image,
                        section2Name: data.info.section2Name,
                        section2Position: data.info.section2Position,
                        section3Image: data.info.section3Image,
                        section3Name: data.info.section3Name,
                        section3Position: data.info.section3Position,
                        section4Image: data.info.section4Image,
                        section4Name: data.info.section4Name,
                        section4Position: data.info.section4Position
                    };
                    setData(temp);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleNexFunction(reCallData, file) {
        const data = { file: file, deleteFile: reCallData.deleteFile, sectionImage: reCallData.sectionImage };
        Axios.post("/style/photoRow/nextFunction", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    onLoad();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleTextChange(event) {
        const { name, value } = event.target;

        const temp = { ...data };

        temp[name] = value;

        setData(temp);
    }

    function handleUpdate() {
        const updateData = {
            values: {
                section1Name: data.section1Name,
                section1Position: data.section1Position,
                section2Name: data.section2Name,
                section2Position: data.section2Position,
                section3Name: data.section3Name,
                section3Position: data.section3Position,
                section4Name: data.section4Name,
                section4Position: data.section4Position
            }
        };

        Axios.post("/style/photoRow/updateTexts", updateData)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setButtonColor("success");
                    setTimeout(() => {
                        setButtonColor("primary");
                    }, 2000);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={ConfigStyles.body}>
            <div style={ConfigStyles.templateTitle}>Template:</div>
            <br />
            <div style={ConfigStyles.templateBorder}>
                <Row>
                    <Col style={ConfigStyles.columns}>1</Col>
                    <Col style={ConfigStyles.columns}>2</Col>
                    <Col style={ConfigStyles.columns}>3</Col>
                    <Col style={ConfigStyles.columns}>4</Col>
                </Row>
                <br />
            </div>
            <br />
            <Row>
                <Col style={ConfigStyles.columnsHeading}>Text</Col>
                <Col style={ConfigStyles.columnsHeading}>
                    Image <br /> {fileDetails.fileSize}MB max per file, {fileDetails.fileMessage}
                </Col>
            </Row>
            <Row>
                <Col style={ConfigStyles.sectionsHeadings}>1</Col>
            </Row>
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>
                        Name:
                        <Form.Control type="text" name="section1Name" maxLength={maxLength} value={data.section1Name} onChange={handleTextChange} />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section1Name.length}/{maxLength}
                    </div>
                    <br />
                    <div style={ConfigStyles.textColumns}>
                        Position:
                        <Form.Control
                            type="text"
                            name="section1Position"
                            maxLength={maxLength}
                            value={data.section1Position}
                            onChange={handleTextChange}
                        />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section1Position.length}/{maxLength}
                    </div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "section1Image", deleteFile: data.section1Image }}
                        directoryPath={"mainStyle/photoRow"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.section1Image}
                </Col>
            </Row>
            <br />
            <Row>
                <Col style={ConfigStyles.sectionsHeadings}>2</Col>
            </Row>
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>
                        Name:
                        <Form.Control type="text" name="section2Name" maxLength={maxLength} value={data.section2Name} onChange={handleTextChange} />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section2Name.length}/{maxLength}
                    </div>
                    <br />
                    <div style={ConfigStyles.textColumns}>
                        Position:
                        <Form.Control
                            type="text"
                            name="section2Position"
                            maxLength={maxLength}
                            value={data.section2Position}
                            onChange={handleTextChange}
                        />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section2Position.length}/{maxLength}
                    </div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "section2Image", deleteFile: data.section2Image }}
                        directoryPath={"mainStyle/photoRow"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.section2Image}
                </Col>
            </Row>
            <br />
            <Row>
                <Col style={ConfigStyles.sectionsHeadings}>3</Col>
            </Row>
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>
                        Name:
                        <Form.Control type="text" name="section3Name" maxLength={maxLength} value={data.section3Name} onChange={handleTextChange} />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section3Name.length}/{maxLength}
                    </div>
                    <br />
                    <div style={ConfigStyles.textColumns}>
                        Position:
                        <Form.Control
                            type="text"
                            name="section3Position"
                            maxLength={maxLength}
                            value={data.section3Position}
                            onChange={handleTextChange}
                        />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section3Position.length}/{maxLength}
                    </div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "section3Image", deleteFile: data.section3Image }}
                        directoryPath={"mainStyle/photoRow"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.section3Image}
                </Col>
            </Row>
            <br />
            <Row>
                <Col style={ConfigStyles.sectionsHeadings}>4</Col>
            </Row>
            <Row>
                <Col>
                    <div style={ConfigStyles.textColumns}>
                        Name: <Form.Control type="text" name="section4Name" value={data.section4Name} onChange={handleTextChange} />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section4Name.length}/{maxLength}
                    </div>
                    <br />
                    <div style={ConfigStyles.textColumns}>
                        Position: <Form.Control type="text" name="section4Position" value={data.section4Position} onChange={handleTextChange} />
                    </div>
                    <div style={ConfigStyles.counter}>
                        {data.section4Position.length}/{maxLength}
                    </div>
                </Col>
                <Col style={ConfigStyles.textColumns}>
                    <UploadComponent
                        isImage={true}
                        fileType={"n/a"}
                        fileLimit={1}
                        fileSize={fileDetails.fileSize}
                        multiple={false}
                        reCallData={{ sectionImage: "section4Image", deleteFile: data.section4Image }}
                        directoryPath={"mainStyle/photoRow"}
                        nextFunction={handleNexFunction}
                        fileMessage={fileDetails.fileMessage}
                    />
                    {data.section4Image}
                </Col>
            </Row>
            <br />
            <Row>
                <Col>
                    <div style={ConfigStyles.columnRight}>
                        <Button style={ConfigStyles.updateButton} onClick={handleUpdate} variant={buttonColor}>
                            Update
                        </Button>
                    </div>
                </Col>
                <Col></Col>
            </Row>
        </div>
    );
}

export default Config;
